import {
    MdDashboard,
    MdPeople,
    MdBarChart,
    MdShoppingCart,
    MdPayment,
    MdCategory,
    MdOutlineLocalOffer,
    MdViewList,
    MdLocalOffer,
    MdWebAsset,
    MdTrendingUp,
    MdAccountBalance,
    MdLocationCity,
    MdBlock,
    MdBugReport,
    MdSensors,
    MdInsights,
    MdOutlineVpnKey,
    MdConstruction,
    MdStorefront,
    MdLinkOff,
    MdWaterfallChart,
} from 'react-icons/md';
import BackOfficeIpBlacklist from 'views/backoffice/ipBlacklist/index';
import BackOfficeLeadFieldBlacklist from 'views/backoffice/leadFieldBlacklist/index';
import { FaWhatsapp } from 'react-icons/fa';
import BackOfficeDashboard from 'views/backoffice/dashboard/index';
import BackOfficeUsers from 'views/backoffice/users/index';
import UserForm from 'views/backoffice/users/form';
import BackOfficeSellersChannels from 'views/backoffice/sellersChannels/index';
import BackOfficeLeads from 'views/backoffice/leads/index';
import BackOfficeLeadsKpi from 'views/backoffice/leadsKpi/index';
import BackOfficeOffers from 'views/backoffice/offers/index';
import BackOfficeOfferDetail from 'views/backoffice/offers/detail';
import BackOfficePurchaseOrders from 'views/backoffice/purchaseOrders/index';
import BackOfficePaymentLogs from 'views/backoffice/paymentLogs/index';
import BackOfficeIndustries from 'views/backoffice/industries/index';
import BackOfficeProductMismatches from 'views/backoffice/productMismatches/index';
import IndustryForm from 'views/backoffice/industries/form';
import BackOfficeFormFields from 'views/backoffice/formFields/index';
import FormFieldForm from 'views/backoffice/formFields/form';
import BackOfficeCoupons from 'views/backoffice/coupons/index';
import CouponForm from 'views/backoffice/coupons/form';
import BackOfficeReferralStats from 'views/backoffice/referralStats/index';
import BackOfficeAffiliateOverview from 'views/backoffice/affiliateOverview/index';
import BackOfficeYieldManagement from 'views/backoffice/yieldManagement/index';
import BackOfficeAccountability from 'views/backoffice/accountability/index';
import BackOfficeFormTemplates from 'views/backoffice/formTemplates/index';
import BackOfficeWhatsappDiffusion from 'views/backoffice/whatsappDiffusion/index';
import BackOfficeWhatsappListDetail from 'views/backoffice/whatsappDiffusion/detail';
import BackOfficeWhatsappTemplates from 'views/backoffice/whatsappTemplates/index';
import BackOfficeCityPrices from 'views/backoffice/cityPrices/index';
import BackOfficeDebug from 'views/backoffice/debug/index';
import BackOfficePixels from 'views/backoffice/pixels/index';
import BackOfficeWalletWithdrawals from 'views/backoffice/walletWithdrawals/index';
import BackOfficeApiKeys from 'views/backoffice/apiKeys/index';
import BackOfficeBatiweb from 'views/backoffice/batiweb/index';
import BackOfficeWaterfall from 'views/backoffice/waterfall/index';
import BackOfficeMarketplaceDisplay from 'views/backoffice/marketplaceDisplay/index';

const backOfficeRoutes: RoutesType[] = [
    // {
    //     name: 'Dashboard',
    //     layout: '/back-office',
    //     path: '/dashboard',
    //     icon: <MdDashboard className="h-5 w-5" />,
    //     component: <BackOfficeDashboard />,
    //     menu: true,
    // },
    {
        name: 'Utilisateurs',
        layout: '/back-office',
        path: '/users',
        icon: <MdPeople className="h-5 w-5" />,
        component: <BackOfficeUsers />,
        menu: true,
    },
    {
        name: 'Edit User',
        layout: '/back-office',
        path: '/users/edit/:id',
        component: <UserForm />,
        menu: false,
    },
    {
        name: 'Sellers Channels',
        layout: '/back-office',
        path: '/sellers-channels',
        component: <BackOfficeSellersChannels />,
        menu: false,
    },
    {
        name: 'Offres',
        layout: '/back-office',
        path: '/offers',
        icon: <MdOutlineLocalOffer className="h-5 w-5" />,
        component: <BackOfficeOffers />,
        menu: true,
        section: 'demand',
    },
    {
        name: 'Offer Detail',
        layout: '/back-office',
        path: '/offers/:offerType/:id',
        component: <BackOfficeOfferDetail />,
        menu: false,
    },
    {
        name: 'Leads',
        layout: '/back-office',
        path: '/leads',
        icon: <MdBarChart className="h-5 w-5" />,
        component: <BackOfficeLeads />,
        menu: true,
    },
    {
        name: 'KPI Leads',
        layout: '/back-office',
        path: '/leads-kpi',
        icon: <MdInsights className="h-5 w-5" />,
        component: <BackOfficeLeadsKpi />,
        menu: true,
        section: 'leads',
    },
    {
        name: 'Bons de commande',
        layout: '/back-office',
        path: '/purchase-orders',
        icon: <MdShoppingCart className="h-5 w-5" />,
        component: <BackOfficePurchaseOrders />,
        menu: true,
        section: 'demand',
    },
    {
        name: 'Paiements',
        layout: '/back-office',
        path: '/payment-logs',
        icon: <MdPayment className="h-5 w-5" />,
        component: <BackOfficePaymentLogs />,
        menu: true,
        section: 'finance',
    },
    {
        name: 'Industries',
        layout: '/back-office',
        path: '/industries',
        icon: <MdCategory className="h-5 w-5" />,
        component: <BackOfficeIndustries />,
        menu: true,
        section: 'catalog',
    },
    {
        name: 'Produits orphelins',
        layout: '/back-office',
        path: '/product-mismatches',
        icon: <MdLinkOff className="h-5 w-5" />,
        component: <BackOfficeProductMismatches />,
        menu: true,
        section: 'catalog',
        badge: 'productMismatches',
    },
    {
        name: 'Marketplace vendeur',
        layout: '/back-office',
        path: '/marketplace-display',
        icon: <MdStorefront className="h-5 w-5" />,
        component: <BackOfficeMarketplaceDisplay />,
        menu: true,
        section: 'sources',
    },
    {
        name: 'Create Industry',
        layout: '/back-office',
        path: '/industries/create',
        component: <IndustryForm />,
        menu: false,
    },
    {
        name: 'Edit Industry',
        layout: '/back-office',
        path: '/industries/edit/:id',
        component: <IndustryForm />,
        menu: false,
    },
    {
        name: 'Champs de formulaire',
        layout: '/back-office',
        path: '/form-fields',
        icon: <MdViewList className="h-5 w-5" />,
        component: <BackOfficeFormFields />,
        menu: true,
        section: 'catalog',
    },
    {
        name: 'Create Form Field',
        layout: '/back-office',
        path: '/form-fields/create',
        component: <FormFieldForm />,
        menu: false,
    },
    {
        name: 'Edit Form Field',
        layout: '/back-office',
        path: '/form-fields/edit/:id',
        component: <FormFieldForm />,
        menu: false,
    },
    {
        name: 'Coupons',
        layout: '/back-office',
        path: '/coupons',
        icon: <MdLocalOffer className="h-5 w-5" />,
        component: <BackOfficeCoupons />,
        menu: true,
        section: 'finance',
    },
    {
        name: 'Create Coupon',
        layout: '/back-office',
        path: '/coupons/create',
        component: <CouponForm />,
        menu: false,
    },
    {
        name: 'Edit Coupon',
        layout: '/back-office',
        path: '/coupons/edit/:id',
        component: <CouponForm />,
        menu: false,
    },
    {
        name: 'Iframes',
        layout: '/back-office',
        path: '/form-templates',
        icon: <MdWebAsset className="h-5 w-5" />,
        component: <BackOfficeFormTemplates />,
        menu: true,
        section: 'sources',
    },
    {
        name: 'Pixels',
        layout: '/back-office',
        path: '/pixels',
        icon: <MdSensors className="h-5 w-5" />,
        component: <BackOfficePixels />,
        menu: true,
        section: 'sources',
    },
    {
        name: 'Stats affiliations',
        layout: '/back-office',
        path: '/referral-stats',
        icon: <MdBarChart className="h-5 w-5" />,
        component: <BackOfficeReferralStats />,
        menu: false,
        section: 'growth',
        tabGroup: 'affiliation',
        tabLabel: 'Statistiques',
    },
    {
        name: 'Affiliation',
        layout: '/back-office',
        path: '/affiliate-overview',
        icon: <MdTrendingUp className="h-5 w-5" />,
        component: <BackOfficeAffiliateOverview />,
        menu: true,
        section: 'growth',
        tabGroup: 'affiliation',
        tabLabel: "Vue d'ensemble",
    },
    {
        name: 'Retraits cagnotte',
        layout: '/back-office',
        path: '/wallet-withdrawals',
        icon: <MdAccountBalance className="h-5 w-5" />,
        component: <BackOfficeWalletWithdrawals />,
        menu: true,
        section: 'finance',
    },
    {
        name: 'Clés API',
        layout: '/back-office',
        path: '/api-keys',
        icon: <MdOutlineVpnKey className="h-5 w-5" />,
        component: <BackOfficeApiKeys />,
        menu: true,
        section: 'sources',
    },
    {
        name: 'Batiweb',
        layout: '/back-office',
        path: '/batiweb',
        icon: <MdConstruction className="h-5 w-5" />,
        component: <BackOfficeBatiweb />,
        menu: true,
        section: 'leads',
    },
    {
        name: 'Waterfall',
        layout: '/back-office',
        path: '/waterfall',
        icon: <MdWaterfallChart className="h-5 w-5" />,
        component: <BackOfficeWaterfall />,
        menu: true,
        section: 'leads',
    },
    {
        name: 'Yield Management',
        layout: '/back-office',
        path: '/yield-management',
        icon: <MdTrendingUp className="h-5 w-5" />,
        component: <BackOfficeYieldManagement />,
        menu: true,
        section: 'demand',
    },
    {
        name: 'Comptabilité',
        layout: '/back-office',
        path: '/accountability',
        icon: <MdAccountBalance className="h-5 w-5" />,
        component: <BackOfficeAccountability />,
        menu: true,
        section: 'finance',
    },
    {
        name: 'WhatsApp',
        layout: '/back-office',
        path: '/whatsapp-diffusion',
        icon: <FaWhatsapp className="h-5 w-5" />,
        component: <BackOfficeWhatsappDiffusion />,
        menu: true,
        section: 'growth',
        tabGroup: 'whatsapp',
        tabLabel: 'Diffusion',
    },
    {
        name: 'WhatsApp Liste',
        layout: '/back-office',
        path: '/whatsapp-diffusion/:id',
        component: <BackOfficeWhatsappListDetail />,
        menu: false,
    },
    {
        name: 'WhatsApp Templates',
        layout: '/back-office',
        path: '/whatsapp-templates',
        icon: <FaWhatsapp className="h-5 w-5" />,
        component: <BackOfficeWhatsappTemplates />,
        menu: false,
        section: 'growth',
        tabGroup: 'whatsapp',
        tabLabel: 'Templates',
    },
    {
        name: 'Data par ville',
        layout: '/back-office',
        path: '/city-prices',
        icon: <MdLocationCity className="h-5 w-5" />,
        component: <BackOfficeCityPrices />,
        menu: true,
        section: 'catalog',
    },
    {
        name: 'Blacklists',
        layout: '/back-office',
        path: '/ip-blacklist',
        icon: <MdBlock className="h-5 w-5" />,
        component: <BackOfficeIpBlacklist />,
        menu: true,
        section: 'leads',
        tabGroup: 'blacklists',
        tabLabel: 'IP et pays',
    },
    {
        name: 'Lead Field Blacklist',
        layout: '/back-office',
        path: '/lead-field-blacklist',
        icon: <MdBlock className="h-5 w-5" />,
        component: <BackOfficeLeadFieldBlacklist />,
        menu: false,
        section: 'leads',
        tabGroup: 'blacklists',
        tabLabel: 'Champs de lead',
    },
    {
        name: 'Debug',
        layout: '/back-office',
        path: '/debug',
        icon: <MdBugReport className="h-5 w-5" />,
        component: <BackOfficeDebug />,
        menu: true,
        section: 'leads',
    },
    // {
    //     name: 'Settings',
    //     layout: '/back-office',
    //     path: '/settings',
    //     icon: <MdSettings className="h-5 w-5" />,
    //     component: <BackOfficeSettings />,
    //     menu: true,
    // },
];

export default backOfficeRoutes;
